import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild,
  inject,
} from '@angular/core';
import { base64ToFile2, readFile } from '@functions/files';
import { CommonVerbsApiService } from '@services/common/common-verbs-api.service';
import { CropModalComponent } from '@modules/ui/common/crop-modal/crop-modal.component';
import { GalleryModalComponent } from '@modules/ui/common/gallery-modal/gallery-modal.component';
import { ICommunityService } from '@tokens/injection.tokens';
import { Media } from '@models/media/media.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxDropzoneChangeEvent } from 'ngx-dropzone';
import { Size } from '@models/common/size.model';
import { ToastrService } from 'ngx-toastr';
import { first } from 'lodash';

@Component({
  selector: 'app-drop-zone-input',
  templateUrl: './drop-zone-input.component.html',
  styleUrls: ['./drop-zone-input.component.scss'],
  styles: [],
})
export class DropZoneInputComponent {
  @Input() accept = 'image/*';
  @Input() label = 'JPG or PNG';
  @Input() multiple = false;
  @Input() media: Media;
  @Input() size: Size;
  @Output() emitter: EventEmitter<Media> = new EventEmitter();
  @Output() remove: EventEmitter<Media> = new EventEmitter();
  communityId? = '';

  constructor(
    private modalService: NgbModal,
    private api: CommonVerbsApiService,
    private toastr: ToastrService
  ) {
    const communityService = inject(ICommunityService);
    this.communityId = communityService.model?.id;
  }

  openModal() {
    const modal = this.modalService.open(GalleryModalComponent, {
      size: 'lg',
      centered: true,
    });
    modal.componentInstance.closeModal.subscribe(() => {
      this.closeModal();
    });
    modal.componentInstance.emitter.subscribe((media: Media) => {
      this.onSelect(media, true);
    });
  }
  openCropModal() {
    const modal = this.modalService.open(CropModalComponent, {
      size: 'lg',
      centered: true,
      backdrop: 'static',
    });
    modal.componentInstance.media = this.media;
    modal.componentInstance.size = this.size;
    modal.componentInstance.emitter = this.emitter;
  }

  onSelect(media: Media, requireCrop = false) {
    this.media = media;
    this.closeModal();
    if (requireCrop) {
      this.api
        .post(`media/encode-image`, { url: media.url })
        .subscribe(base64 => {
          if (base64) {
            base64ToFile2(
              `${base64}`,
              `${this.media.name}`,
              `image/${this.media.extension}`
            ).then(file => {
              if (file) {
                this.media.file = file;
                this.openCropModal();
              }
            });
          }
        });
    } else {
      this.emitter.emit(this.media);
    }
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  onRemove(e: Media) {
    this.media.file = null;
    this.media.url = null;
    this.remove.emit(e);
  }

  prepare(event: NgxDropzoneChangeEvent) {
    const file = event.addedFiles[0];
    if (file) {
      this.media.file = file;

      readFile(file).then(() => {
        const params = {
          file: file,
          communityId: this.communityId ?? null,
          source: this.communityId ? 'COMMUNITY' : 'UNKNOWN',
        };
        this.api.form<Media[]>(`media/upload`, params).subscribe({
          error: err => this.toastr.error(err?.message || 'An error occurred.'),
          next: response => {
            const resp = first(response)!;

            this.media.file = file;
            this.media.url = resp.url;
            this.openCropModal();
          },
        });
      });
    }
  }
}
